import { tooltipData, tooltipHelp } from "../createTooltip.js";
import MapboxDraw from "@mapbox/mapbox-gl-draw";

const DrawPointMode = MapboxDraw.modes.draw_point;

const _onStop = DrawPointMode.onStop;

DrawPointMode.onStop = function (state, e) {
  const result = _onStop.apply(this, [state, e]);

  const feature = state.point.toGeoJSON();

  tooltipData([feature], "point");
  tooltipHelp([feature], "point");
  state.point.properties.sysType = "point";
  state.point.properties.sysData = tooltipData([feature], "point", false, true);

  return result;
};

export default DrawPointMode;
